import { SelectableListComponent } from './selectable-list/selectable-list.component';

export const Components = [
	SelectableListComponent,
];
